export default "__VITE_ASSET__DbrcHyB7__"